import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";

const TimerButton = ({
  waitTime = 15,
  text = "Time Left:",
  onClick = () => {},
}) => {
  const [timeLeft, setTimeLeft] = useState(waitTime);

  useEffect(() => {
    if (timeLeft === 0) return;

    const timerId = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearTimeout(timerId);
  }, [timeLeft]);

  return (
    <button
      className={`timer-button ${timeLeft > 0 ? "disabled" : "enabled"}`}
      disabled={timeLeft > 0}
      onClick={() => onClick()}
    >
      {timeLeft > 0 ? `${text} ${timeLeft}s` : "TENTAR NOVAMENTE"}
    </button>
  );
};

TimerButton.propTypes = {
  text: PropTypes.string.isRequired,
  waitTime: PropTypes.number,
  onClick: PropTypes.func,
};

export default TimerButton;
